import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';

import CarolineCoile from 'dpl/assets/overview_pages/caroline-coile-round.jpg';
import NateRitter from 'dpl/assets/overview_pages/nate-ritter-round.jpg';

const TOOLTIP_AVATAR_SIZE = '104px';
const GOOD_DOG_CONTENT_TEXT =
  'Content on Good Dog is generated, fact-checked, and evaluated by qualified writers and veterinarians.';

function TooltipContent({ imgSrc, header, children }) {
  return (
    <div className="ph2 pv2 ph8-sm pv8-sm tc">
      <SmartImage
        className="br-100"
        width={TOOLTIP_AVATAR_SIZE}
        height={TOOLTIP_AVATAR_SIZE}
        src={imgSrc}
      />
      <div className="pv6 bb b--light-gray">
        <h5 className="f5 mb2">{header}</h5>
        {children}
      </div>
      <p className="font-16 dark-gray pt6">{GOOD_DOG_CONTENT_TEXT}</p>
    </div>
  );
}

TooltipContent.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export function CarolineCoileTooltipContent() {
  return (
    <TooltipContent imgSrc={CarolineCoile} header="Caroline Coile, Ph.D.">
      <p className="font-16 dark-gray">
        Caroline Coile specializes in canine science, health, breeds and
        competitions. Caroline has won 20 national dog-writing awards, and was a
        2015 Inductee into the Dog Writers Association of America Hall of Fame.
        She’s written thousands of magazine and web articles about dogs in
        addition to 34 dog books.
      </p>
    </TooltipContent>
  );
}

export function NateRitterTooltipContent() {
  const [showMoreText, setShowMoreText] = useState(false);
  return (
    <TooltipContent imgSrc={NateRitter} header="Nate Ritter, DVM">
      <p className="branch font-16 bg-branch-light max-content mx-auto ph4 pv1 br-pill">
        Veterinarian reviewer
      </p>
      <p className="font-16 dark-gray pv4">
        Dr. Nate Ritter, DVM is the Veterinary Medical Director at Good Dog. He
        earned his Bachelor of Science in Biology from Lafayette College and his
        Doctor of Veterinary Medicine degree from Virginia-Maryland College of
        Veterinary Medicine.
        {showMoreText &&
          ' He is a member of the American Veterinary Medical Association, New York State Veterinary Medical Society, the Veterinary Medical Association of New York City, and the Society for Theriogenology. Additionally, he is a USDA-accredited veterinarian.'}
      </p>
      <button
        type="button"
        className="font-16 fw-medium stone-700"
        onClick={() => setShowMoreText(prevState => !prevState)}
      >
        {showMoreText ? 'Read less' : 'Read more'}
      </button>
    </TooltipContent>
  );
}
